<template>
  <div>
    <v-tabs
      fixed-tabs
      grow
      v-model="selectedTab"
      :slider-color="sliderColor"
    >

      <v-tab href="#capturado" @click="cambiarANoFirmados">
        <div v-if="!$vuetify.breakpoint.xsOnly">
          <v-icon v-if="selectedTab === 'capturado'" class="mr-3" color="red darken-2">cloud_upload</v-icon>
          <v-icon v-else class="mr-3" color="grey darken-1">cloud_upload</v-icon>
        </div>
        <span v-if="selectedTab === 'capturado'" class="red--text text--darken-2">Capturados</span>
        <span v-else class="grey--text text--darken-1">Capturados</span>
      </v-tab>
      <v-tab href="#firmado" @click="cambiarAFirmados">
        <div v-if="!$vuetify.breakpoint.xsOnly">
          <v-icon v-if="selectedTab === 'firmado'" class="mr-3" color="purple darken-2">cloud_queue</v-icon>
          <v-icon v-else class="mr-3" color="grey darken-1">cloud_queue</v-icon>
        </div>
        <span v-if="selectedTab === 'firmado'" class="purple--text text--darken-2">Firmados</span>
        <span v-else class="grey--text text--darken-1">Firmados</span>
      </v-tab>
      <v-tab href="#enviado" @click="cambiarASubidos">
        <div v-if="!$vuetify.breakpoint.xsOnly">
          <v-icon v-if="selectedTab === 'enviado'" class="mr-3" color="blue darken-2">cloud_download</v-icon>
          <v-icon v-else class="mr-3" color="grey darken-1">cloud_download</v-icon>
        </div>
        <span v-if="selectedTab === 'enviado'" class="blue--text text--darken-2">Enviados</span>
        <span v-else class="grey--text text--darken-1">Enviados</span>
      </v-tab>
      <v-tab href="#autenticado" @click="cambiarAAutenticados">
        <div v-if="!$vuetify.breakpoint.xsOnly">
          <v-icon v-if="selectedTab === 'autenticado'" class="mr-3" color="green darken-2">cloud_done</v-icon>
          <v-icon v-else class="mr-3" color="grey darken-1">cloud_done</v-icon>
        </div>
        <span v-if="selectedTab === 'autenticado'" class="green--text text--darken-2">Autenticados</span>
        <span v-else class="grey--text text--darken-1">Autenticados</span>
      </v-tab>
    </v-tabs>

    <v-toolbar
      class="elevation-1 toolbar-fix"
      flat
      dense
      color="white"
    >
      <v-btn
        v-if="selected.length === 0"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">check_box_outline_blank</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0 && selected.length < lotesTitulos.data.length"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">indeterminate_check_box</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0 && selected.length === lotesTitulos.data.length"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">check_box</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length === 0"
        icon
        @click="getLotesTitulos(selectedTab)"
      >
        <v-icon color="grey darken-1">refresh</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0 && (selectedTab !== 'enviado' || selectedTab !== 'autenticado')"
        icon
        @click="eliminarLotesTitulos"
      >
        <v-icon color="grey darken-1">delete</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0"
        icon
        @click="copiarTexto"
      >
        <v-icon color="grey darken-1">content_copy</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <span color="grey darken-1">{{ lotesTitulos.count > 1 ? ((lotesTitulos.current_page - 1) * lotesTitulos.per_page + 1) : 0 }}-{{ lotesTitulos.count ? ((lotesTitulos.current_page - 1) * lotesTitulos.per_page) + lotesTitulos.count : 0 }} de {{ lotesTitulos.total ? lotesTitulos.total : 0 }}</span>

      <v-btn
        :disabled="lotesTitulos.current_page <= 1"
        icon
        @click="getLotesTitulosPreviousPage"
      >
        <v-icon color="grey darken-1">navigate_before</v-icon>
      </v-btn>

      <v-btn
        :disabled="lotesTitulos.current_page >= lotesTitulos.last_page"
        icon
        @click="getLotesTitulosNextPage"
      >
        <v-icon
          color="grey darken-1">navigate_next</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="settingsDialog = true"
      >
        <v-icon color="grey darken-1">settings</v-icon>
      </v-btn>

    </v-toolbar>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="lotesTitulos.data"
      :pagination.sync="pagination"
      :no-data-text="noDataText"
      :no-results-text="NoResultsText"
      :loading="loading"
      item-key="id"
      hide-actions
      >
      <template slot="headers" slot-scope="props">
        <tr>
          <th></th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
              'text-xs-left',
              header.visibility ? 'hidden-print-only' : 'hidden-screen-only'
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <v-hover>
        <tr
          @click="mostrarLoteTitulos(props.item)"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 2 : 0}`"
        >
          <td @click.stop="props.selected = !props.selected">
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td v-if="incluyeBusqueda(props.item.uuid)" :class="[headers[0].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.uuid }}</strong></td>
          <td v-else :class="[headers[0].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.uuid }}</td>

          <td v-if="incluyeBusqueda(props.item.nombre)" :class="[headers[1].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.nombre }}</strong></td>
          <td v-else :class="[headers[1].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.nombre }}</td>

          <td v-if="incluyeBusqueda(props.item.nombre_campus)" :class="[headers[2].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.nombre_campus }}</strong></td>
          <td v-else :class="[headers[2].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.campus.nombre }}</td>

          <td v-if="incluyeBusqueda(props.item.tipo_rvoe)" :class="[headers[3].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.tipo_rvoe }}</strong></td>
          <td v-else :class="[headers[3].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.tipo_rvoe }}</td>

          <td :class="[headers[4].visibility ? 'hidden-print-only' : 'hidden-screen-only']">
            <v-chip small color="indigo" text-color="white">
              <v-avatar class="indigo darken-4"><strong>{{ props.item.titulos_count }}</strong></v-avatar>
              Títulos
            </v-chip>
          </td>

          <td v-if="incluyeBusqueda(props.item.fecha_capturado)" :class="[headers[5].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.fecha_capturado }}</strong></td>
          <td v-else :class="[headers[5].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.fecha_capturado }}</td>

          <td v-if="incluyeBusqueda(props.item.fecha_firmado)" :class="[headers[6].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.fecha_firmado }}</strong></td>
          <td v-else :class="[headers[6].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.fecha_firmado }}</td>

          <td v-if="incluyeBusqueda(props.item.fecha_enviado)" :class="[headers[7].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.fecha_enviado }}</strong></td>
          <td v-else :class="[headers[7].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.fecha_enviado }}</td>

          <td v-if="incluyeBusqueda(props.item.fecha_autenticado)" :class="[headers[8].visibility ? 'hidden-print-only' : 'hidden-screen-only']"><strong>{{ props.item.fecha_autenticado }}</strong></td>
          <td v-else :class="[headers[8].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.fecha_autenticado }}</td>

          <div v-if="hover" class="lotes-titulos-fix-1">
            <div
              class="justify-center layout grey lighten-3 lotes-titulos-fix-2"
              :class="selectedTab !== 'enviado' ? 'lotes-titulos-fix-left-1': 'lotes-titulos-fix-left-2'"
            >
              <v-tooltip bottom>
                <v-btn slot="activator" icon ripple @click.stop="mostrarInformacionLoteTitulos(props.item)">
                  <v-icon color="grey darken-1">info</v-icon>
                </v-btn>
                <span>Mostrar lote de títulos</span>
              </v-tooltip>
              <v-tooltip
                v-if="selectedTab !== 'enviado'"
                bottom
              >
                <v-btn slot="activator" icon ripple @click.stop="eliminarLoteTitulos(props.item)">
                  <v-icon color="grey darken-1">delete</v-icon>
                </v-btn>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </div>
        </tr>
        </v-hover>
      </template>
    </v-data-table>

    <v-dialog
      v-model="settingsDialog"
      persistent
      max-width="400px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Configuración</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-list>
              <v-subheader>
                Número de filas por página
              </v-subheader>

              <v-slider
                v-model="pagination.rowsPerPage"
                thumb-label="always"
                step="10"
                :thumb-size="24"
                :min="10"
                :max="100"
                ticks
                tick-size="2"
              ></v-slider>

              <v-subheader>
                Columnas a mostrar
              </v-subheader>
              
              <v-list-tile
                v-for="(header, index) in headers"
                :key="index"
              >
                <v-list-tile-action>
                  <v-switch
                    v-model="header.visibility"
                    color="primary"
                  ></v-switch>
                </v-list-tile-action>
                <v-list-tile-title>{{ header.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" flat @click="settingsDialog = false">Cancelar</v-btn>
          <v-btn color="primary darken-1" flat @click="aplicarConfiguracion">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { api } from "~/config";
import Form from '~/mixins/form'

export default {
  mixins: [Form],

  data: () => ({
    selectedTab: 'capturado',
    sliderColor: 'red darken-2',

    loading: false,

    noDataText: "No hay lotes de títulos registrados",
    NoResultsText: "No hay lotes de títulos que coincidan con tus criterios",

    selected: [],

    headers: [
      { text: "ID", value: "uuid", visibility: true },
      { text: "Nombre", value: "nombre", visibility: true },
      { text: "Campus", value: "campus.nombre", visibility: true },
      { text: "Tipo RVOE", value: "tipo_rvoe", visibility: true },
      { text: "Cantidad", value: "titulos_count", visibility: true },
      { text: "Fecha de Subida", value: "fecha_capturado", visibility: false },
      { text: "Fecha de Firma", value: "fecha_firmado", visibility: false },
      { text: "Fecha de Envío", value: "fecha_enviado", visibility: false },
      { text: "Fecha de Autenticación", value: "fecha_autenticado", visibility: false },
    ],

    settingsDialog: false,
    
    pagination: {
      rowsPerPage: 10,
      sortBy: 'id',
    },

    lotesTitulos: {}
  }),

  computed: {
    ...mapGetters({
      live_mode: "auth/live_mode",
      busqueda: "auth/busqueda"
    })
  },

  watch: {
    live_mode(val) {
      if (val !== undefined) {
        this.$store.dispatch('auth/guardarBusqueda', { busqueda: null })
        this.getLotesTitulos(this.selectedTab)
      }
    },

    busqueda(val) {
      if (val) {
        this.$router.replace('#buscar/' + val.trim())
      } else {
        this.$router.replace('#' + this.selectedTab)
      }
      this.getLotesTitulos(this.selectedTab)
    }
  },

  methods: {
    cambiarANoFirmados() {
      this.$router.replace('#capturado')
      this.getLotesTitulos('capturado')
      this.sliderColor = 'red darken-2'
    },

    cambiarAFirmados() {
      this.$router.replace('#firmado')
      this.getLotesTitulos('firmado')
      this.sliderColor = 'purple darken-2'
    },

    cambiarASubidos() {
      this.$router.replace('#enviado')
      this.getLotesTitulos('enviado')
      this.sliderColor = 'blue darken-2'
    },

    cambiarAAutenticados() {
      this.$router.replace('#autenticado')
      this.getLotesTitulos('autenticado')
      this.sliderColor = 'green darken-2'
    },

    incluyeBusqueda(val) {
      if(val && this.busqueda) {
        let value = val.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        let value_two = this.busqueda.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        return value.includes(value_two)
      }
    },

    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.lotesTitulos.data.slice()
    },
    
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    getLotesTitulos(val) {
      this.loading = true
      axios
        .get(api.path("titulos"), {
          params: {
            estado: val,
            page_size: this.pagination.rowsPerPage,
            q: this.busqueda
          }
        })
        .then(res => {
          this.lotesTitulos = res.data
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors)
        })
        .then(() => {
          this.loading = false
        })
    },

    getLotesTitulosPreviousPage() {
      this.loading = true
      axios
        .get(api.path("titulos"), {
          params: {
            estado: this.selectedTab,
            page_size: this.pagination.rowsPerPage,
            page: this.lotesTitulos.current_page - 1,
            q: this.busqueda
          }
        })
        .then(res => {
          this.lotesTitulos = res.data
          this.selected = []
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors);
        })
        .then(() => {
          this.loading = false
        });
    },

    getLotesTitulosNextPage() {
      this.loading = true
      axios
        .get(api.path("titulos"), {
          params: {
            estado: this.selectedTab,
            page_size: this.pagination.rowsPerPage,
            page: this.lotesTitulos.current_page + 1,
            q: this.busqueda
          }
        })
        .then(res => {
          this.lotesTitulos = res.data
          this.selected = []
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors);
        })
        .then(() => {
          this.loading = false
        });
    },

    eliminarLoteTitulos(val) {
      this.$confirm("¿Desea eliminar este lote de títulos?").then(
        res => {
          if (res) {
            axios
              .delete(api.path("titulos.single", { id: val.id }))
              .then(res => {
                this.$toast.success("Lote de títulos eliminado correctamente.")
                this.selected = []
                this.getLotesTitulos(this.selectedTab)
              })
              .catch(err => {
                this.$toast.error("No se puede eliminar el lote de títulos.")
                this.handleErrors(err.response.data.errors)
              })
              .then(() => {})
          }
        }
      )
    },

    eliminarLotesTitulos() {
      this.$confirm("¿Desea eliminar los lotes de títulos seleccionados?").then(
        res => {
          if (res) {

            let ids = []

            this.selected.forEach(function(val) {
              ids.push(val.id)
            })

            axios
              .delete(api.path("titulos"), {
                params: {
                  ids: ids.join()
                }
              })
              .then(res => {
                this.$toast.success("Lotes de títulos eliminados correctamente.")
                this.selected = []
                this.getLotesTitulos(this.selectedTab)
              })
              .catch(err => {
                this.$toast.error("No se pueden eliminar los lotes de títulos.")
                this.handleErrors(err.response.data.errors)
              })
              .then(() => {})
          }
        }
      )
    },

    copiarTexto() {
      let data = ''

      this.selected.forEach(function(val) {
        data = data + val.uuid + '\t'
        data = data + val.nombre + '\t'
        data = data + val.campus.nombre + '\t'
        data = data + val.titulos_count + '\t'
        data = data + val.fecha_capturado + '\t'
        data = data + val.fecha_firmado + '\t'
        data = data + val.fecha_enviado + '\t',
        data = data + val.fecha_autenticado + '\n'

      })

      let me = this
      this.$copyText(data).then(function (e) {
        me.$toast.success("Datos copiados al portapapeles.")
      }, function (e) {
        me.$toast.success("No se puede copiar los datos al portapapeles.")
      })
    },

    mostrarLoteTitulos(val) {
      this.$router.push({ name: 'lotes-titulos-titulos', params: { id: val.id } })
    },

    mostrarInformacionLoteTitulos(val) {
      this.$router.push({ name: 'lotes-titulos-mostrar', params: { id: val.id } })
    },

    aplicarConfiguracion() {
      this.settingsDialog = false
      this.getLotesTitulos(this.selectedTab)
      localStorage.setItem('lotes-titulos.pagination', JSON.stringify({
        descending: this.pagination.descending,
        rowsPerPage: this.pagination.rowsPerPage,
        sortBy: this.pagination.sortBy
      }))
      localStorage.setItem('lotes-titulos.headers', JSON.stringify(this.headers))
      this.selected = []
    },
  },

  mounted() {
    if (localStorage.hasOwnProperty('lotes-titulos.pagination')) {
      this.pagination = JSON.parse(localStorage.getItem('lotes-titulos.pagination'))
    }

    if (localStorage.hasOwnProperty('lotes-titulos.headers')) {
      this.headers = JSON.parse(localStorage.getItem('lotes-titulos.headers'))
    }

    let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')
    
    if (tab[0] === '') {
      this.cambiarANoFirmados()
    } else if (tab[0] === '#capturado') {
      this.selectedTab = 'capturado'
      this.sliderColor = 'red darken-2'
      this.getLotesTitulos('capturado')
    } else if (tab[0] === '#firmado') {
      this.selectedTab = 'firmado'
      this.sliderColor = 'purple darken-2'
      this.getLotesTitulos('firmado')
    } else if (tab[0] === '#enviado') {
      this.selectedTab = 'enviado'
      this.sliderColor = 'blue darken-2'
      this.getLotesTitulos('enviado')
    } else if (tab[0] === '#autenticado') {
      this.selectedTab = 'autenticado'
      this.sliderColor = 'green darken-2'
      this.getLotesTitulos('autenticado')
    } else if (tab[0] === '#buscar') {
      let busqueda = decodeURI( tab[1] )
      this.$store.dispatch('auth/guardarBusqueda', { busqueda: busqueda })
    } else {
      if (this.busqueda) {
        this.$store.dispatch('auth/guardarBusqueda', { busqueda: null })
      }
    }
  }
}
</script>

<style>
	.toolbar-fix {
    position: sticky !important;
    z-index: 2 !important;
    top: 48px !important;
	}

  .table-fix {
    padding-top: 48px !important;
	}

  .lotes-titulos-fix-1 {
    position: relative !important;
	}

  .lotes-titulos-fix-2 {
    position: absolute !important;
    z-index: 1 !important;
    
    top: 1px !important;
    height: 47px !important;
	}

  .lotes-titulos-fix-left-1 {
    left: -104px !important;
	}

  .lotes-titulos-fix-left-2 {
    left: -52px !important;
	}
</style>

